import { b as __awaiter, c as __generator, _ as _assign } from './tslib.es6-604585c1.js';
import { useEffect, useState, useCallback, useLayoutEffect } from 'react';
import AnalyticsService from '@picsart/rc/services/analytics';
import Logger from './services/logger/index.js';
import { authStates, authStateKey } from './models/user/index.js';
import { REGISTRATION_DONE, ANALYTICS_PLATFORM_TYPE, API_URL, ResponseStatus, FACEBOOK_APP_ID, IS_SUBSCRIBED_COOKIE_NAME, GT_USER_ID_COOKIE_NAME, GOOGLE_CLIENT_ID } from './configs/constants/index.js';
import { a as ANALYTICS_SCREEN_NAME_KEY, b as ANALYTICS_CONSENTS_KEY, C as ConsentType, S as SocialProviderOptions, c as AnalyticsActionOptions, d as ComponentsOptions, e as RegErrorReasons, f as AuthActionOptions, g as StatusOptions, h as AuthActionConfig, F as FACEBOOK_PLATFORM_SCRIPT_URL, A as AuthFlow, P as ProviderOptions, i as AnalyticsSocialItemOptions, G as GOOGLE_PLATFORM_SCRIPT_URL } from './constants-3bc57a75.js';
import { s as socialHeaders, u as usernameSuggestion, U as UserField, g as getHeaders, a as UserField$1 } from './usernameSuggestion-9f27552b.js';
import { u as useAuthContext, a as authStatus } from './authContext-4a1a5892.js';
import { setCookie } from './cookie/index.js';
import { removeStorage, setStorage, getStorage } from './services/browserStorage/index.js';
import { addRecentLoginMethod } from './services/recentLoginMethods/index.js';
import { u as useRegistrationFormContext } from './RegistrationFormContext-de1e9c93.js';
import fetcher from './fetcher/index.js';
import HttpService from './services/http/index.js';
import errorLogger, { BUGSNAG_STATUSES } from './services/errorLogger/index.js';
import { G as GoogleCallbackSource, g as getConsents, a as getIsMaximizer } from './styles-3006bf33.js';
import getReCaptchaToken from './getReCaptchaToken/index.js';
import getResponseErrorMessage from './getResponseErrorMessage/index.js';
import CleverTapService from './services/clevertapService/index.js';
import noop from '@picsart/rc/noop';
import IS_BROWSER from './isBrowser/index.js';
import useDelayedScript from './useDelayedScript/index.js';
import { g as googleButtonTheme, a as googleButtonSize, b as googleButtonLabelText, c as googleButtonShape } from './constants-1c6c7b5f.js';

var fireSocialButtonClickAnalytics = function fireSocialButtonClickAnalytics(social) {
  AnalyticsService.sendEvent('button_click', {
    screen_name: 'registration_popup',
    item: social
  });
};

var fireCombinedAnalytics = function fireCombinedAnalytics(_a) {
  var _b, _c, _d;
  var action = _a.action,
    userData = _a.userData,
    triggeredFrom = _a.triggeredFrom,
    socialName = _a.socialName,
    isAuthCombined = _a.isAuthCombined,
    select_by = _a.select_by,
    flow = _a.flow,
    _e = _a.fromWelcomeBack,
    fromWelcomeBack = _e === void 0 ? false : _e;
  var id = (userData === null || userData === void 0 ? void 0 : userData.id) || ((_b = userData.user) === null || _b === void 0 ? void 0 : _b.id);
  var email = (userData === null || userData === void 0 ? void 0 : userData.email) || ((_c = userData.user) === null || _c === void 0 ? void 0 : _c.email);
  var name = (_d = userData.user) === null || _d === void 0 ? void 0 : _d.name;
  try {
    if ((userData === null || userData === void 0 ? void 0 : userData.registered) && socialName) {
      AnalyticsService.pushDataLayer({
        event: 'complete_registration'
      });
    }
    AnalyticsService.pushDataLayer({
      event: 'gtm_set',
      data: {
        parameters: {
          gtm_userID: id,
          gtm_userEmail: email || '',
          gtm_userName: name || ''
        }
      }
    });
    AnalyticsService.pushDataLayer({
      pulse: 'state',
      user_id: id
    });
    AnalyticsService.sendEvent(REGISTRATION_DONE, {
      provider: socialName !== null && socialName !== void 0 ? socialName : 'Picsart',
      registration_type: select_by === GoogleCallbackSource.OneTap ? 'google_one_tap' : 'standard',
      braze: true,
      action_button: triggeredFrom,
      action: action,
      fromWelcomeBack: fromWelcomeBack,
      flow: flow,
      flow_type: isAuthCombined && 'monetization_combined',
      platform: ANALYTICS_PLATFORM_TYPE
    }, undefined, 2);
    removeStorage(ANALYTICS_SCREEN_NAME_KEY, false);
    removeStorage(ANALYTICS_CONSENTS_KEY, false);
  } catch (error) {
    console.error('Error firing analytics:', error);
    errorLogger.trigger(error, BUGSNAG_STATUSES.ERROR);
  }
};

var handleNewSocialRequest = function handleNewSocialRequest(_a) {
  var flow = _a.flow,
    credential = _a.credential,
    provider = _a.provider,
    username = _a.username,
    checkUser = _a.checkUser,
    checkedStates = _a.checkedStates,
    setCurrentPage = _a.setCurrentPage,
    setUsername = _a.setUsername,
    triggeredFrom = _a.triggeredFrom,
    onClick = _a.onClick,
    isAuthCombined = _a.isAuthCombined,
    select_by = _a.select_by,
    _b = _a.fromWelcomeBack,
    fromWelcomeBack = _b === void 0 ? false : _b,
    _c = _a.checkBiometricState,
    checkBiometricState = _c === void 0 ? false : _c;
  return __awaiter(void 0, void 0, void 0, function () {
    var processedCheckedStates, consents;
    var _d;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          processedCheckedStates = select_by === GoogleCallbackSource.OneTap ? _assign(_assign({}, checkedStates), (_d = {}, _d[ConsentType.biometric] = true, _d)) : checkedStates;
          consents = getConsents(processedCheckedStates);
          return [4, HttpService.post("".concat(API_URL, "/user-account/auth/social"), {
            provider: SocialProviderOptions[provider],
            data: {
              token: credential
            },
            consents: consents,
            username: username || undefined
          }, {
            logErrors: true,
            headers: _assign(_assign({}, socialHeaders), {
              'check-biometric-consent': checkBiometricState.toString()
            }),
            credentials: 'include'
          }).then(function (data) {
            var user = data.user,
              removal_info = data.removal_info,
              status = data.status;
            if (status === ResponseStatus.success) {
              fireCombinedAnalytics({
                flow: flow,
                action: (data === null || data === void 0 ? void 0 : data.registered) ? AnalyticsActionOptions.SignUp : AnalyticsActionOptions.SignIn,
                userData: data,
                triggeredFrom: triggeredFrom,
                socialName: SocialProviderOptions[provider],
                isAuthCombined: isAuthCombined,
                select_by: select_by,
                fromWelcomeBack: fromWelcomeBack
              });
              checkUser((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
              onClick === null || onClick === void 0 ? void 0 : onClick(SocialProviderOptions[provider], user)(null);
            } else {
              checkUser(user, removal_info);
            }
          })["catch"](function (err) {
            return __awaiter(void 0, void 0, void 0, function () {
              var error, username_1;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    return [4, err.json()];
                  case 1:
                    error = _b.sent();
                    if (!(error.reason === RegErrorReasons.Consents && setCurrentPage)) return [3, 6];
                    if (!!error.missingConsents.includes(ConsentType.biometric)) return [3, 2];
                    setCurrentPage(ComponentsOptions.ToGetStarted);
                    return [3, 6];
                  case 2:
                    _b.trys.push([2, 4,, 5]);
                    usernameSuggestion.setUserData(error.email ? error.email : error.name, error.email ? UserField.email : UserField.name);
                    return [4, usernameSuggestion.suggest()];
                  case 3:
                    username_1 = _b.sent();
                    setUsername(username_1);
                    return [3, 5];
                  case 4:
                    _b.sent();
                    setUsername === null || setUsername === void 0 ? void 0 : setUsername(error.email);
                    return [3, 5];
                  case 5:
                    setCurrentPage(ComponentsOptions.UsernameFormSSO);
                    _b.label = 6;
                  case 6:
                    console.error('handleNewSocialRequest -', err);
                    return [2];
                }
              });
            });
          })];
        case 1:
          _e.sent();
          return [2];
      }
    });
  });
};
function handleSocialRequestByProvider(credential, provider, redirectAfterEmailConfirmation) {
  return __awaiter(this, void 0, void 0, function () {
    var response, result, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 3,, 4]);
          return [4, fetcher("".concat(API_URL, "/user-account/auth/social"), {
            body: JSON.stringify({
              provider: provider,
              redirectAfterEmailConfirmation: redirectAfterEmailConfirmation,
              data: {
                token: credential
              }
            }),
            credentials: 'include',
            headers: socialHeaders,
            method: 'POST'
          })];
        case 1:
          response = _a.sent();
          if (!response.ok) {
            throw new Error("Failed to fetch: ".concat(response.statusText));
          }
          return [4, response.json()];
        case 2:
          result = _a.sent();
          return [2, result];
        case 3:
          error_1 = _a.sent();
          console.error('Error in handleSocialRequestByProvider:', error_1);
          throw error_1;
        case 4:
          return [2];
      }
    });
  });
}

var handleAppleRequest = function handleAppleRequest(_a) {
  var flow = _a.flow,
    appleData = _a.appleData,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    setCurrentPage = _a.setCurrentPage,
    checkedStates = _a.checkedStates,
    setSocialData = _a.setSocialData,
    setUsername = _a.setUsername,
    isAuthCombined = _a.isAuthCombined,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  return __awaiter(void 0, void 0, void 0, function () {
    var data, id_token, _b;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          data = appleData && appleData.authorization;
          id_token = data.id_token;
          setSocialData && setSocialData({
            provider: SocialProviderOptions.apple,
            credential: id_token
          });
          _b = data && !appleData.error;
          if (!_b) return [3, 2];
          return [4, handleNewSocialRequest({
            flow: flow,
            credential: id_token,
            provider: SocialProviderOptions.apple,
            checkUser: checkUser,
            checkedStates: checkedStates,
            setCurrentPage: setCurrentPage,
            setUsername: setUsername,
            triggeredFrom: triggeredFrom,
            isAuthCombined: isAuthCombined,
            fromWelcomeBack: fromWelcomeBack,
            checkBiometricState: checkBiometricState
          })];
        case 1:
          _b = _c.sent();
          _c.label = 2;
        case 2:
          return [2];
      }
    });
  });
};

var handleGoogleResponse = function handleGoogleResponse(_a) {
  var flow = _a.flow,
    accountData = _a.accountData,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    onClick = _a.onClick,
    checkedStates = _a.checkedStates,
    setCurrentPage = _a.setCurrentPage,
    setSocialData = _a.setSocialData,
    setUsername = _a.setUsername,
    isAuthCombined = _a.isAuthCombined,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  return __awaiter(void 0, void 0, void 0, function () {
    var credential, select_by;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (!(accountData === null || accountData === void 0 ? void 0 : accountData.credential)) {
            throw Error('Empty account data!');
          }
          setTimeout(function () {
            if (accountData.credential) {
              setSocialData && setSocialData({
                provider: SocialProviderOptions.google,
                credential: accountData.credential
              });
            }
          }, 100);
          credential = accountData.credential, select_by = accountData.select_by;
          return [4, handleNewSocialRequest({
            flow: flow,
            credential: credential,
            provider: SocialProviderOptions.google,
            checkUser: checkUser,
            checkedStates: checkedStates,
            setCurrentPage: setCurrentPage,
            setUsername: setUsername,
            triggeredFrom: triggeredFrom,
            onClick: onClick,
            isAuthCombined: isAuthCombined,
            select_by: select_by,
            fromWelcomeBack: fromWelcomeBack,
            checkBiometricState: checkBiometricState
          })];
        case 1:
          _b.sent();
          return [2];
      }
    });
  });
};

var handleFacebookResponse$1 = function handleFacebookResponse(_a) {
  var _b, _c;
  var flow = _a.flow,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    checkedStates = _a.checkedStates,
    setCurrentPage = _a.setCurrentPage,
    setSocialData = _a.setSocialData,
    setUsername = _a.setUsername,
    isAuthCombined = _a.isAuthCombined,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  var fbScope = {
    scope: 'email,public_profile,user_photos',
    auth_type: 'rerequest'
  };
  (_c = (_b = window === null || window === void 0 ? void 0 : window.FB) === null || _b === void 0 ? void 0 : _b.login) === null || _c === void 0 ? void 0 : _c.call(_b, function (result) {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);
            if (!(result === null || result === void 0 ? void 0 : result.authResponse)) return [3, 2];
            setSocialData && setSocialData({
              provider: SocialProviderOptions.facebook,
              credential: result.authResponse.accessToken
            });
            return [4, handleNewSocialRequest({
              flow: flow,
              credential: result.authResponse.accessToken,
              provider: SocialProviderOptions.facebook,
              checkUser: checkUser,
              checkedStates: checkedStates,
              setCurrentPage: setCurrentPage,
              setUsername: setUsername,
              triggeredFrom: triggeredFrom,
              isAuthCombined: isAuthCombined,
              fromWelcomeBack: fromWelcomeBack,
              checkBiometricState: checkBiometricState
            })];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [3, 4];
          case 3:
            error_1 = _a.sent();
            console.error('Error in handleFacebookResponse:', error_1);
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, fbScope);
};

var handleSubmitRequest = function handleSubmitRequest(_a) {
  var flow = _a.flow,
    body = _a.body,
    action = _a.action,
    onSuccess = _a.onSuccess,
    onTerminatedAccount = _a.onTerminatedAccount,
    triggeredFrom = _a.triggeredFrom,
    setServerStatus = _a.setServerStatus,
    reCaptchaToken = _a.reCaptchaToken,
    isAuthCombined = _a.isAuthCombined,
    externalProvider = _a.externalProvider,
    fromWelcomeBack = _a.fromWelcomeBack,
    _b = _a.checkBiometricState,
    checkBiometricState = _b === void 0 ? false : _b;
  return __awaiter(void 0, void 0, void 0, function () {
    var _c, analyticName, endpoint, headers, bodyData, isMaximizer;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          _c = AuthActionConfig[action], analyticName = _c.analyticName, endpoint = _c.endpoint;
          headers = _assign(_assign({}, getHeaders()), {
            'g-recaptcha-action': action,
            'g-recaptcha-token': reCaptchaToken
          });
          bodyData = body;
          if (action === AuthActionOptions.SignUp) {
            isMaximizer = getIsMaximizer();
            if (isMaximizer) {
              bodyData.redirectAfterEmailConfirmation = "".concat(window.location.origin, "/create?maximizer=true");
            }
          }
          delete bodyData.isLocal;
          if (action === AuthActionOptions.SignIn) {
            delete bodyData.email;
          }
          AnalyticsService.sendEvent('popup_action', {
            name: analyticName,
            action: 'action_button'
          });
          setServerStatus({
            type: StatusOptions.Submitting
          });
          return [4, fetcher("".concat(API_URL, "/").concat(endpoint), {
            method: 'POST',
            body: JSON.stringify(bodyData),
            headers: _assign(_assign({}, headers), {
              'check-biometric-consent': checkBiometricState.toString()
            }),
            credentials: 'include'
          }).then(function (data) {
            return __awaiter(void 0, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    if (!((data === null || data === void 0 ? void 0 : data.status) === ResponseStatus.success)) return [3, 2];
                    return [4, fireCombinedAnalytics({
                      flow: flow,
                      action: analyticName,
                      userData: data,
                      triggeredFrom: triggeredFrom,
                      socialName: externalProvider,
                      isAuthCombined: isAuthCombined,
                      fromWelcomeBack: fromWelcomeBack
                    })];
                  case 1:
                    _a.sent();
                    if (action === AuthActionOptions.SignUp) {
                      CleverTapService.scheduleRegistrationDone((data === null || data === void 0 ? void 0 : data.user) || data);
                    }
                    onSuccess((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
                    return [3, 6];
                  case 2:
                    if (!(data === null || data === void 0 ? void 0 : data.removal_info)) return [3, 5];
                    if (!onTerminatedAccount) return [3, 4];
                    return [4, onTerminatedAccount(data.removal_info)];
                  case 3:
                    _a.sent();
                    _a.label = 4;
                  case 4:
                    return [3, 6];
                  case 5:
                    setServerStatus({
                      type: StatusOptions.Error,
                      message: data === null || data === void 0 ? void 0 : data.message,
                      reason: data === null || data === void 0 ? void 0 : data.reason
                    });
                    _a.label = 6;
                  case 6:
                    return [2];
                }
              });
            });
          })["catch"](function (err) {
            setServerStatus({
              statusCode: err.statusCode,
              type: StatusOptions.Error,
              message: getResponseErrorMessage(err),
              reason: (err === null || err === void 0 ? void 0 : err.reason) || ''
            });
          })];
        case 1:
          _d.sent();
          return [2];
      }
    });
  });
};
var handleSubmit = function handleSubmit(_a) {
  var flow = _a.flow,
    email = _a.email,
    username = _a.username,
    password = _a.password,
    code = _a.code,
    preventReCaptcha = _a.preventReCaptcha,
    action = _a.action,
    checkUser = _a.checkUser,
    onTerminatedAccount = _a.onTerminatedAccount,
    triggeredFrom = _a.triggeredFrom,
    setServerStatus = _a.setServerStatus,
    checkedStates = _a.checkedStates,
    isAuthCombined = _a.isAuthCombined,
    redirectAfterEmailConfirmation = _a.redirectAfterEmailConfirmation,
    externalProvider = _a.externalProvider,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  var consents = getConsents(checkedStates);
  var reqData = {
    password: password,
    redirectAfterEmailConfirmation: redirectAfterEmailConfirmation
  };
  if (action === AuthActionOptions.SignUp) {
    reqData = _assign(_assign(_assign({}, reqData), {
      email: email
    }), {
      consents: consents
    });
  } else if (action === AuthActionOptions.SignInWithCode) {
    reqData = _assign(_assign(_assign(_assign({}, reqData), {
      email: email
    }), {
      code: code
    }), {
      provider: externalProvider
    });
  } else {
    reqData = _assign(_assign({}, reqData), {
      username: username || email
    });
  }
  if (action === AuthActionOptions.SignIn || action === AuthActionOptions.SignInWithCode) {
    if (!preventReCaptcha) {
      getReCaptchaToken(action).then(function (_a) {
        var status = _a.status,
          token = _a.token;
        if (status === ResponseStatus.success) {
          handleSubmitRequest({
            flow: flow,
            body: reqData,
            action: action,
            onSuccess: checkUser,
            setServerStatus: setServerStatus,
            onTerminatedAccount: onTerminatedAccount,
            triggeredFrom: triggeredFrom,
            reCaptchaToken: token,
            isAuthCombined: isAuthCombined,
            fromWelcomeBack: fromWelcomeBack,
            externalProvider: externalProvider,
            checkBiometricState: checkBiometricState
          });
        }
      })["catch"](function (err) {
        setServerStatus === null || setServerStatus === void 0 ? void 0 : setServerStatus({
          type: StatusOptions.Error,
          message: getResponseErrorMessage(err)
        });
      });
    } else {
      handleSubmitRequest({
        flow: flow,
        body: reqData,
        action: action,
        onSuccess: checkUser,
        onTerminatedAccount: onTerminatedAccount,
        triggeredFrom: triggeredFrom,
        setServerStatus: setServerStatus,
        isAuthCombined: isAuthCombined,
        externalProvider: externalProvider,
        checkBiometricState: checkBiometricState
      });
    }
  } else if (!preventReCaptcha) {
    getReCaptchaToken(action).then(function (_a) {
      var status = _a.status,
        token = _a.token;
      if (status === ResponseStatus.success) {
        handleSubmitRequest({
          flow: flow,
          body: reqData,
          action: AuthActionOptions.SignUp,
          onSuccess: checkUser,
          setServerStatus: setServerStatus,
          onTerminatedAccount: onTerminatedAccount,
          triggeredFrom: triggeredFrom,
          reCaptchaToken: token,
          isAuthCombined: isAuthCombined,
          externalProvider: externalProvider,
          checkBiometricState: checkBiometricState
        });
      }
    })["catch"](function (err) {
      setServerStatus === null || setServerStatus === void 0 ? void 0 : setServerStatus({
        type: StatusOptions.Error,
        message: getResponseErrorMessage(err)
      });
    });
  } else {
    handleSubmitRequest({
      flow: flow,
      body: reqData,
      action: AuthActionOptions.SignUp,
      onSuccess: checkUser,
      onTerminatedAccount: onTerminatedAccount,
      triggeredFrom: triggeredFrom,
      setServerStatus: setServerStatus,
      isAuthCombined: isAuthCombined,
      externalProvider: externalProvider,
      checkBiometricState: checkBiometricState
    });
  }
};

var emailCodeSendRequest = function emailCodeSendRequest(_a) {
  var preventReCaptcha = _a.preventReCaptcha,
    email = _a.email;
  return new Promise(function (resolve, reject) {
    var emailCodeSendInner = function emailCodeSendInner() {
      return __awaiter(void 0, void 0, void 0, function () {
        var headers, recaptchaResponse, status_1, token, err_1, data, status_2, err_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              headers = getHeaders();
              if (!!preventReCaptcha) return [3, 4];
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4, getReCaptchaToken(AuthActionOptions.SignIn)];
            case 2:
              recaptchaResponse = _a.sent();
              status_1 = recaptchaResponse.status, token = recaptchaResponse.token;
              if (status_1 === ResponseStatus.success) {
                headers['g-recaptcha-token'] = token;
                headers['g-recaptcha-action'] = AuthActionOptions.SignIn;
              }
              return [3, 4];
            case 3:
              err_1 = _a.sent();
              reject(new Error(getResponseErrorMessage(err_1)));
              return [3, 4];
            case 4:
              _a.trys.push([4, 6,, 7]);
              return [4, fetcher("".concat(API_URL, "/user-account/auth/signin/code/send"), {
                method: 'POST',
                body: JSON.stringify({
                  email: email
                }),
                headers: headers,
                credentials: 'include'
              })];
            case 5:
              data = _a.sent();
              status_2 = data.status;
              if (status_2 === ResponseStatus.success) {
                resolve({
                  type: StatusOptions.Success,
                  message: data
                });
              }
              return [3, 7];
            case 6:
              err_2 = _a.sent();
              reject(new Error(getResponseErrorMessage(err_2)));
              return [3, 7];
            case 7:
              return [2];
          }
        });
      });
    };
    emailCodeSendInner();
  });
};

var handleFacebookResponse = function handleFacebookResponse(observeUserData) {
  var _a, _b;
  (_b = (_a = window === null || window === void 0 ? void 0 : window.FB) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? void 0 : _b.call(_a, function (result) {
    if (result === null || result === void 0 ? void 0 : result.authResponse) {
      handleSocialRequestByProvider(result.authResponse.accessToken, 'facebook').then(function (userData) {
        if (userData === null || userData === void 0 ? void 0 : userData.token) {
          observeUserData(userData);
        }
        setStorage(authStateKey, authStates.authorized);
      })["catch"](function (error) {
        console.error('Error handling Facebook response:', error);
      });
    }
  }, {
    scope: 'email,public_profile'
  });
};
function useFacebookAuth(enable) {
  var isScriptLoaded = useDelayedScript(FACEBOOK_PLATFORM_SCRIPT_URL);
  useEffect(function () {
    if (enable) {
      if (!isScriptLoaded) {
        return;
      }
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          cookie: true,
          xfbml: false,
          version: 'v21.0'
        });
      };
    }
  }, [enable, isScriptLoaded]);
}

var MILLISECONDS_PER_SECOND = 1000;
var SECONDS_PER_MINUTE = 60;
var LOCALE = 'en-US';
var formatter = new Intl.DateTimeFormat(LOCALE, {
  timeZone: 'UTC',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  fractionalSecondDigits: 3,
  hour12: false
});
var isDateLessThanOneMinute = function isDateLessThanOneMinute(dateString) {
  var now = new Date();
  var date = new Date(dateString);
  var utcDateStr = formatter.format(date);
  var utcNowStr = formatter.format(now);
  var utcDate = new Date(utcDateStr);
  var utcNow = new Date(utcNowStr);
  var diffInMilliSeconds = utcNow.getTime() - utcDate.getTime();
  var diffInMinutes = Math.round(diffInMilliSeconds / MILLISECONDS_PER_SECOND / SECONDS_PER_MINUTE);
  return diffInMinutes < 1;
};

var sharedAnalytics = function sharedAnalytics(_a) {
  var _b, _c, _d, _e, _f, _g;
  var view = _a.view,
    data = _a.data,
    setErrorMessage = _a.setErrorMessage,
    onSuccess = _a.onSuccess,
    triggeredFrom = _a.triggeredFrom,
    _h = _a.isSocial,
    isSocial = _h === void 0 ? false : _h,
    socialName = _a.socialName,
    flow = _a.flow;
  onSuccess && (data === null || data === void 0 ? void 0 : data.user) && onSuccess((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
  !isSocial && AnalyticsService.sendEvent('popup_action', {
    name: view && (data === null || data === void 0 ? void 0 : data.registered) ? 'sign_up' : 'sign_in',
    action: 'action_button'
  });
  if ((data === null || data === void 0 ? void 0 : data.registered) && isSocial) {
    AnalyticsService.pushDataLayer({
      event: 'complete_registration'
    });
  }
  AnalyticsService.pushDataLayer({
    event: 'gtm_set',
    data: {
      parameters: {
        gtm_userID: (data === null || data === void 0 ? void 0 : data.id) || ((_b = data.user) === null || _b === void 0 ? void 0 : _b.id) || ((_c = data.response) === null || _c === void 0 ? void 0 : _c.id),
        gtm_userEmail: (data === null || data === void 0 ? void 0 : data.email) || ((_d = data.user) === null || _d === void 0 ? void 0 : _d.email) || ((_e = data.response) === null || _e === void 0 ? void 0 : _e.email) || '',
        gtm_userName: ((_f = data === null || data === void 0 ? void 0 : data.user) === null || _f === void 0 ? void 0 : _f.name) || ''
      }
    }
  });
  AnalyticsService.pushDataLayer({
    pulse: 'state',
    user_id: (data === null || data === void 0 ? void 0 : data.id) || ((_g = data.user) === null || _g === void 0 ? void 0 : _g.id)
  });
  var accountCreatedAtTimeStamp = data === null || data === void 0 ? void 0 : data.created;
  var isNewlyCreatedUser = accountCreatedAtTimeStamp && isDateLessThanOneMinute(accountCreatedAtTimeStamp);
  AnalyticsService.sendEvent(REGISTRATION_DONE, {
    provider: socialName !== null && socialName !== void 0 ? socialName : 'Picsart',
    action: view || isNewlyCreatedUser ? 'sign_up' : 'sign_in',
    registration_type: 'standard',
    braze: true,
    action_button: triggeredFrom,
    flow: flow,
    platform: ANALYTICS_PLATFORM_TYPE
  }, function () {
    !isSocial && setErrorMessage && setErrorMessage('');
  });
};

var handleSocialData = function handleSocialData(socialName, flow, data, isSignUpView, checkUser, triggeredFrom) {
  if (data && data.status === ResponseStatus.success) {
    sharedAnalytics({
      view: isSignUpView,
      data: {
        user: data
      },
      setErrorMessage: noop,
      onSuccess: checkUser,
      triggeredFrom: triggeredFrom,
      isSocial: true,
      socialName: socialName,
      flow: flow
    });
  } else {
    throw new Error('userData is Empty');
  }
};
var handleSocialSignIn = function handleSocialSignIn(_a) {
  var socialName = _a.socialName,
    flow = _a.flow,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    _b = _a.userData,
    userData = _b === void 0 ? null : _b;
    _a.isAuthCombined;
  return function (e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (!IS_BROWSER) {
      return;
    }
    handleBearerSocialSignIn(socialName, flow, userData, true, checkUser, triggeredFrom)(e);
  };
};
var handleBearerSocialSignIn = function handleBearerSocialSignIn(socialName, flow, userData, isSignUpView, checkUser, triggeredFrom) {
  return function (e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (IS_BROWSER) {
      var data_1 = userData;
      setStorage(authStateKey, authStates.authorized);
      if (socialName === 'facebook') {
        var observeUserData = function observeUserData(userSocialData) {
          data_1 = userSocialData;
          handleSocialData(socialName, flow, data_1, isSignUpView, checkUser, triggeredFrom);
        };
        handleFacebookResponse(observeUserData);
        return;
      }
      handleSocialData(socialName, flow, data_1, isSignUpView, checkUser, triggeredFrom);
    }
  };
};

function useAuth(_a) {
  var _this = this;
  var _b = _a.flow,
    flow = _b === void 0 ? AuthFlow.Default : _b,
    triggeredFrom = _a.triggeredFrom,
    authSuccessHandler = _a.authSuccessHandler,
    onTerminatedAccount = _a.onTerminatedAccount,
    preventReCaptcha = _a.preventReCaptcha,
    isAuthCombined = _a.isAuthCombined,
    showUsernameFormOnSignIn = _a.showUsernameFormOnSignIn,
    showUsernameFormOnSignUp = _a.showUsernameFormOnSignUp;
  var _c = useState(''),
    redirectAfterEmailConfirmation = _c[0],
    setRedirectAfterEmailConfirmation = _c[1];
  useEffect(function () {
    setRedirectAfterEmailConfirmation(getStorage('redirectAfterEmailConfirmation', false) || '');
  }, []);
  var _d = useAuthContext(),
    onUserChange = _d.onUserChange,
    onTokenChange = _d.onTokenChange,
    onStatusChange = _d.onStatusChange,
    tokenDataRef = _d.tokenDataRef;
  var _e = useRegistrationFormContext(),
    setCurrentPage = _e.setCurrentPage,
    setSocialData = _e.setSocialData,
    checkedStates = _e.checkedStates,
    stagedUserInfo = _e.stagedUserInfo,
    setStagedUserInfo = _e.setStagedUserInfo,
    setUsername = _e.setUsername;
  var _f = useState(null),
    terminatedAccount = _f[0],
    setTerminatedAccount = _f[1];
  var _g = useState({
      type: StatusOptions.Default,
      message: '',
      reason: ''
    }),
    serverStatus = _g[0],
    setServerStatus = _g[1];
  var handleTerminatedAccount = useCallback(function (data) {
    onTerminatedAccount === null || onTerminatedAccount === void 0 ? void 0 : onTerminatedAccount();
    setTerminatedAccount(data || null);
  }, [onTerminatedAccount]);
  var finalizeAuth = useCallback(function (provider, user) {
    var _a, _b, _c;
    if ((_a = user === null || user === void 0 ? void 0 : user.token) === null || _a === void 0 ? void 0 : _a.access_token) {
      var observeTokenData = user.token;
      tokenDataRef && (tokenDataRef.current = observeTokenData);
      onTokenChange === null || onTokenChange === void 0 ? void 0 : onTokenChange(observeTokenData);
      onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(authStatus.done);
    }
    setStorage(authStateKey, authStates.authorized);
    Logger.deprecate('user.subscribed & user.isTrialUsed are deprecated properties of user in AuthContext. Please consider using user.subscription object for accessing these props.');
    var subscribed = (_b = user.subscription) === null || _b === void 0 ? void 0 : _b.granted;
    var isTrialUsed = (_c = user.subscription) === null || _c === void 0 ? void 0 : _c.is_trial_used;
    onUserChange === null || onUserChange === void 0 ? void 0 : onUserChange(_assign(_assign({}, user), {
      subscribed: subscribed,
      isTrialUsed: isTrialUsed
    }));
    addRecentLoginMethod({
      id: user.id,
      username: user.username,
      email: user.email,
      provider: provider
    });
    onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(authStatus.resolved);
    authSuccessHandler === null || authSuccessHandler === void 0 ? void 0 : authSuccessHandler(user);
  }, [authSuccessHandler, onStatusChange, onTokenChange, onUserChange, tokenDataRef]);
  var finalizeAuthWithStagedUser = useCallback(function (username) {
    if (stagedUserInfo) {
      finalizeAuth(stagedUserInfo.provider, username ? _assign(_assign({}, stagedUserInfo.user), {
        username: username
      }) : stagedUserInfo.user);
      setStagedUserInfo(null);
    }
  }, [finalizeAuth, setStagedUserInfo, stagedUserInfo]);
  var _checkUser = useCallback(function (provider, user, removalInfo, action) {
    var _a;
    if (user) {
      if ((_a = user.subscription) === null || _a === void 0 ? void 0 : _a.granted) {
        setCookie(IS_SUBSCRIBED_COOKIE_NAME, 'true');
      }
      if (user.id) {
        setCookie(GT_USER_ID_COOKIE_NAME, "".concat(user.id));
      }
      AnalyticsService.pushDataLayer({
        pulse: 'state',
        user_id: (user === null || user === void 0 ? void 0 : user.id) || null
      });
      var showUsernameForm = action === AuthActionOptions.SignUp ? showUsernameFormOnSignUp : showUsernameFormOnSignIn;
      if (showUsernameForm && provider === ProviderOptions.email) {
        setStagedUserInfo({
          provider: provider,
          user: user
        });
        usernameSuggestion.setUserData(user.email, UserField$1.email);
        setCurrentPage(ComponentsOptions.UsernameForm);
      } else {
        finalizeAuth(provider, user);
      }
    }
    if (removalInfo) {
      handleTerminatedAccount(removalInfo);
    }
  }, [showUsernameFormOnSignUp, showUsernameFormOnSignIn, setStagedUserInfo, setCurrentPage, finalizeAuth, handleTerminatedAccount]);
  var handleGeneralSocialServices = useCallback(function (_a) {
    var provider = _a.provider,
      credential = _a.credential,
      username = _a.username;
    handleNewSocialRequest({
      flow: flow,
      credential: credential,
      provider: provider,
      username: username,
      checkUser: function checkUser(user, removalInfo) {
        return _checkUser(provider, user, removalInfo);
      },
      triggeredFrom: triggeredFrom,
      setSocialData: setSocialData,
      setCurrentPage: setCurrentPage,
      setUsername: setUsername,
      checkedStates: checkedStates,
      isAuthCombined: isAuthCombined,
      checkBiometricState: showUsernameFormOnSignUp
    })["catch"](console.error);
  }, [_checkUser, checkedStates, flow, isAuthCombined, setCurrentPage, setSocialData, setUsername, showUsernameFormOnSignUp, triggeredFrom]);
  var handleAppleService = useCallback(function (data, fromWelcomeBack) {
    if ('authorization' in data) {
      fireSocialButtonClickAnalytics(AnalyticsSocialItemOptions.Apple);
      handleAppleRequest({
        flow: flow,
        appleData: data,
        checkUser: function checkUser(user, removalInfo) {
          return _checkUser(SocialProviderOptions.apple, user, removalInfo);
        },
        triggeredFrom: triggeredFrom,
        setCurrentPage: setCurrentPage,
        setUsername: setUsername,
        checkedStates: checkedStates,
        setSocialData: setSocialData,
        isAuthCombined: isAuthCombined,
        fromWelcomeBack: fromWelcomeBack,
        checkBiometricState: showUsernameFormOnSignUp
      })["catch"](console.error);
    }
  }, [flow, triggeredFrom, setCurrentPage, setUsername, checkedStates, setSocialData, isAuthCombined, showUsernameFormOnSignUp, _checkUser]);
  var handleGoogleService = useCallback(function (data, fromWelcomeBack, onClick) {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            fireSocialButtonClickAnalytics(AnalyticsSocialItemOptions.Google);
            return [4, handleGoogleResponse({
              flow: flow,
              accountData: data,
              checkUser: function checkUser(user, removalInfo) {
                return _checkUser(SocialProviderOptions.google, user, removalInfo);
              },
              triggeredFrom: triggeredFrom,
              setCurrentPage: setCurrentPage,
              checkedStates: checkedStates,
              onClick: onClick,
              setSocialData: setSocialData,
              setUsername: setUsername,
              isAuthCombined: isAuthCombined,
              fromWelcomeBack: fromWelcomeBack,
              checkBiometricState: showUsernameFormOnSignUp
            })["catch"](console.error)];
          case 1:
            _a.sent();
            return [2];
        }
      });
    });
  }, [flow, triggeredFrom, setCurrentPage, checkedStates, setSocialData, setUsername, isAuthCombined, showUsernameFormOnSignUp, _checkUser]);
  var handleFacebookService = useCallback(function (fromWelcomeBack) {
    fireSocialButtonClickAnalytics(AnalyticsSocialItemOptions.Facebook);
    handleFacebookResponse$1({
      flow: flow,
      checkUser: function checkUser(user, removalInfo) {
        return _checkUser(SocialProviderOptions.facebook, user, removalInfo);
      },
      triggeredFrom: triggeredFrom,
      setCurrentPage: setCurrentPage,
      checkedStates: checkedStates,
      setSocialData: setSocialData,
      setUsername: setUsername,
      isAuthCombined: isAuthCombined,
      fromWelcomeBack: fromWelcomeBack,
      checkBiometricState: showUsernameFormOnSignUp
    });
  }, [flow, triggeredFrom, setCurrentPage, checkedStates, setSocialData, setUsername, isAuthCombined, showUsernameFormOnSignUp, _checkUser]);
  var handleSocials = useCallback(function (socialName, userData) {
    if (userData === void 0) {
      userData = null;
    }
    return handleSocialSignIn({
      flow: flow,
      socialName: socialName,
      checkUser: function checkUser(user, removalInfo) {
        return _checkUser(socialName, user, removalInfo);
      },
      triggeredFrom: triggeredFrom,
      userData: userData,
      isAuthCombined: isAuthCombined
    });
  }, [_checkUser, flow, isAuthCombined, triggeredFrom]);
  var onSubmit = useCallback(function (_a) {
    var email = _a.email,
      action = _a.action,
      password = _a.password,
      code = _a.code,
      username = _a.username,
      checkedStates = _a.checkedStates,
      fromWelcomeBack = _a.fromWelcomeBack,
      externalProvider = _a.externalProvider;
    return handleSubmit({
      flow: flow,
      email: email,
      username: username,
      password: password,
      code: code,
      preventReCaptcha: preventReCaptcha,
      externalProvider: externalProvider,
      checkUser: function checkUser(user, removalInfo) {
        return _checkUser(externalProvider !== null && externalProvider !== void 0 ? externalProvider : ProviderOptions.email, user, removalInfo, action);
      },
      onTerminatedAccount: handleTerminatedAccount,
      triggeredFrom: triggeredFrom,
      action: action,
      setServerStatus: setServerStatus,
      checkedStates: checkedStates,
      fromWelcomeBack: fromWelcomeBack,
      isAuthCombined: isAuthCombined,
      redirectAfterEmailConfirmation: redirectAfterEmailConfirmation,
      finalizeAuth: finalizeAuth,
      checkBiometricState: showUsernameFormOnSignUp
    });
  }, [flow, preventReCaptcha, handleTerminatedAccount, triggeredFrom, setServerStatus, isAuthCombined, redirectAfterEmailConfirmation, finalizeAuth, showUsernameFormOnSignUp, _checkUser]);
  var onEmailCodeSend = useCallback(function (email) {
    return emailCodeSendRequest({
      email: email,
      preventReCaptcha: preventReCaptcha
    });
  }, [preventReCaptcha]);
  return {
    onSubmit: onSubmit,
    handleSocials: handleSocials,
    handleTerminatedAccount: handleTerminatedAccount,
    handleAppleService: handleAppleService,
    handleGoogleService: handleGoogleService,
    handleFacebookService: handleFacebookService,
    handleGeneralSocialServices: handleGeneralSocialServices,
    finalizeAuthWithStagedUser: finalizeAuthWithStagedUser,
    checkUser: _checkUser,
    onEmailCodeSend: onEmailCodeSend,
    terminatedAccount: terminatedAccount,
    serverStatus: serverStatus
  };
}

function useGoogleAuth(handleGoogleResponse, buttonElement, buttonWidth, onClick, hideOneTap, disableGoogleInit, prefilledEmail) {
  var _a, _b;
  if (buttonElement === void 0) {
    buttonElement = null;
  }
  if (buttonWidth === void 0) {
    buttonWidth = null;
  }
  if (onClick === void 0) {
    onClick = null;
  }
  if (hideOneTap === void 0) {
    hideOneTap = false;
  }
  var _c = useAuthContext(),
    tokenData = _c.tokenData,
    status = _c.status;
  var _d = useState(false),
    isInitialised = _d[0],
    setInitialised = _d[1];
  var oneTapExcludedPaths = ['/about-us', '/press-kit', '/challenges', '/terms-of-use', '/privacy-policy', '/community-guidelines', '/copyright-dispute-policy', '/challenge/*'];
  var redirectUrl = IS_BROWSER && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href);
  var pathName = IS_BROWSER && ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname);
  var excluded = oneTapExcludedPaths && oneTapExcludedPaths.length > 0 ? pathName && oneTapExcludedPaths.includes(pathName) : false;
  var isScriptLoaded = useDelayedScript(GOOGLE_PLATFORM_SCRIPT_URL, false);
  var googleResponseHandler = useCallback(function (accountData) {
    var _a;
    (_a = handleGoogleResponse(accountData, false, onClick)) === null || _a === void 0 ? void 0 : _a["catch"](console.error);
  }, [handleGoogleResponse, onClick]);
  useEffect(function () {
    var _a, _b, _c, _d;
    if (IS_BROWSER && (tokenData === null || tokenData === void 0 ? void 0 : tokenData.access_token)) {
      (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
    } else if (IS_BROWSER && isScriptLoaded && !isInitialised && ((_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) && !disableGoogleInit) {
      var config = {
        redirectUrl: redirectUrl,
        googleAccountConfigs: {
          client_id: GOOGLE_CLIENT_ID,
          login_hint: prefilledEmail
        },
        paths: ['/sign-in', '/sign-up']
      };
      window.google.accounts.id.initialize(_assign(_assign({}, config.googleAccountConfigs), {
        callback: function callback(accountData) {
          return googleResponseHandler(accountData);
        }
      }));
      setInitialised(true);
    }
  }, [googleResponseHandler, redirectUrl, isInitialised, isScriptLoaded, tokenData === null || tokenData === void 0 ? void 0 : tokenData.access_token, disableGoogleInit, prefilledEmail]);
  useLayoutEffect(function () {
    var _a;
    if (IS_BROWSER && isScriptLoaded && isInitialised && buttonElement && ((_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts)) {
      var buttonRenderOptions = {
        theme: googleButtonTheme.outline,
        size: googleButtonSize.large,
        text: googleButtonLabelText.continue_with,
        shape: googleButtonShape.pill,
        width: buttonWidth !== null && buttonWidth !== void 0 ? buttonWidth : buttonElement.getBoundingClientRect().width
      };
      window.google.accounts.id.renderButton(buttonElement, buttonRenderOptions);
    }
  }, [buttonElement, buttonWidth, isInitialised, isScriptLoaded]);
  useEffect(function () {
  }, [excluded, hideOneTap, isInitialised, isScriptLoaded, pathName, status]);
}

export { useGoogleAuth as a, useFacebookAuth as b, handleNewSocialRequest as h, useAuth as u };
//# sourceMappingURL=useGoogleAuth-11864a7a.js.map
